import Vue from 'vue'
import Vuex from 'vuex'
import api from './func/api'

Vue.use(Vuex)

export default new Vuex.Store({
    state: () => window.data,
    getters: {
        routerName:(state)=>state.router_name,
        list:(state,getters)=>(list_field)=>{
            if(!state.hasOwnProperty(list_field)){
                return []
            }
            return state[list_field].list
        },
        page:(state,getters)=>(list_field)=>{
            if(!state.hasOwnProperty(list_field)){
                return 0
            }
            return state[list_field].page
        },
        totalPage:(state,getters)=>(list_field)=>{
            if(!state.hasOwnProperty(list_field)){
                return 0
            }
            return state[list_field].totalPage
        }
    },
    mutations: {
        setList(state, data) {


            state[data.list_field].list = _.concat(state[data.list_field].list, data.list);
            state[data.list_field].page = data.page;
        },
    },
    actions: {
        getList({commit, state}, req) {
            let data = {};
            console.log('getList')
            if(state.api === 'get_list_by_type_keyword'){
                api.post(`/api/${state.api}/${req.list_field}/${state.target_id}/${state.keyword}/${req.start}/${req.range}`, data).then(function (response) {
                    if (response.data.sResult) {
                        commit('setList', response.data);
                    }

                })
            }else{
                api.post(`/api/${state.api}/${req.list_field}/${state.target_id}/${req.start}/${req.range}`, data).then(function (response) {
                    if (response.data.sResult) {
                        commit('setList', response.data);
                    }

                })
            }


        },
    }
})
